import { render, staticRenderFns } from "./CompanyNewUserSetting.vue?vue&type=template&id=162a2380"
import script from "./CompanyNewUserSetting.vue?vue&type=script&lang=js"
export * from "./CompanyNewUserSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('162a2380')) {
      api.createRecord('162a2380', component.options)
    } else {
      api.reload('162a2380', component.options)
    }
    module.hot.accept("./CompanyNewUserSetting.vue?vue&type=template&id=162a2380", function () {
      api.rerender('162a2380', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companysetting/CompanyNewUserSetting.vue"
export default component.exports